// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__29Rb-","productName":"Table_productName__3pX1E"};